import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const Footer = ({ config }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/subscribe", { email });
      setDone(true);
      toast.success("You're on the list. First to know when the fire's lit.");
    } catch {
      toast.error("That didn't land. Try again.");
    }
  };

  return (
    <footer className="border-t border-hearth-line bg-hearth-bg">
      <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-16">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <img src="/images/logo-mark.png" alt="Hat, beard and halo mark" className="h-12 w-auto" data-testid="footer-logo" />
            <span className="font-sign gilded-sign uppercase tracking-[0.12em]">No BS Counselling</span>
          </div>
          <p className="text-hearth-muted text-sm leading-relaxed">
            Forty years, one bloke, and a fire worth sitting beside. Practising on the Coast, Australia.
          </p>
          <div className="mt-6 space-y-3 text-sm" data-testid="footer-contact">
            {config?.contact_phone ? (
              <>
                <a data-testid="footer-call-link" href={`tel:${config.contact_phone}`} className="block text-hearth-ochre hover:text-hearth-ink transition-colors">
                  Call Matt: {config.contact_phone.replace("+61", "0").replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")}
                </a>
                {config?.contact_whatsapp && (
                  <a data-testid="footer-whatsapp-link" href={`https://wa.me/${config.contact_whatsapp}`} target="_blank" rel="noopener noreferrer" className="block text-hearth-ochre hover:text-hearth-ink transition-colors">
                    Text or WhatsApp: {config.contact_phone.replace("+61", "0").replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")}
                  </a>
                )}
              </>
            ) : (
              <p className="text-hearth-muted">Direct line &amp; WhatsApp opening soon — the form and the booking page are live now.</p>
            )}
          </div>
        </div>
        <div>
          <p className="eyebrow mb-6">The Relaunch List</p>
          <p className="text-hearth-muted text-sm mb-4">Be first through the door when the books open wide.</p>
          {done ? (
            <p data-testid="subscribe-success" className="text-hearth-ochre font-essay italic text-lg">Good. We'll find you.</p>
          ) : (
            <form onSubmit={subscribe} className="flex" data-testid="subscribe-form">
              <input
                data-testid="subscribe-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 bg-hearth-surface border border-hearth-line px-4 py-3 text-sm text-hearth-ink placeholder:text-hearth-muted focus:outline-none focus:border-hearth-ochre"
              />
              <button data-testid="subscribe-submit-button" className="bg-hearth-ember hover:bg-hearth-ochre hover:text-hearth-bg text-hearth-ink text-xs font-semibold uppercase tracking-widest px-5 transition-colors">
                Join
              </button>
            </form>
          )}
        </div>
        <div>
          <p className="eyebrow mb-6">The Fine Print, Minus the BS</p>
          <p className="text-hearth-muted text-sm leading-relaxed">
            What you tell Matt stays with Matt. This site collects the bare minimum needed to book you in, runs no advertising trackers, and sells nothing about you to anyone. Ever.
          </p>
          <p className="text-hearth-muted text-xs mt-6">If life is at risk right now, call Lifeline on 13 11 14 or emergency on 000.</p>
        </div>
      </div>
      <div className="border-t border-hearth-line py-6 text-center text-xs text-hearth-muted tracking-widest uppercase">
        No BS Counselling · The Coast · Australia
      </div>
    </footer>
  );
};
